import {
  Grid,
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Spacer
} from '@chakra-ui/react'
import { FC, useEffect, useRef, useState } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'
import useParametrizationConfigTolerancia from '@hook/parametrization/use-config-tolerancia'
import useAuth from '@hook/shared/use-auth'
import useFilters from '@hook/shared/use-filters'

import Layout from '@component/Layout'
import Filter from '@component/Shared/Filter'

import PurchaseCronAlcadaConfig from './AlcadaConfigPurchase'
import CronogramaCompraCalendar from './ConfigPurchase'
import EscopoConfigPurchase from './EscopoConfigPurchase'
import PurchaseCronFeriasConfig from './FeriasConfigPurchase'
import PurchaseCronToleranciaConfig from './ToleranciaConfigPurchase'
import PurchaseCronUserConfig from './UserConfigPurchase'
const PurchaseConfig: FC = () => {
  const { getFilters, loading } = useFilters()
  const { companies } = useFilters()
  const {
    handleCompanieId,
    companieId,
    getDataAlcadas,
    getDataFerias,
    getDataUsers,
    getCronogramaCompra,
    confirmDiscardCronograma
  } = useParametrizationConfigPurchase()
  const { getDataTolerancias } = useParametrizationConfigTolerancia()
  const [tabIndex, setTabIndex] = useState(0)
  const { companies: authCompanies } = useAuth()

  // Sempre as versões mais recentes das buscas, sem que o efeito abaixo dependa delas
  // (mudam de identidade a cada troca de comprador/filtro e disparariam buscas repetidas)
  const fetchers = useRef({
    getCronogramaCompra,
    getDataUsers,
    getDataAlcadas,
    getDataFerias,
    getDataTolerancias
  })
  fetchers.current = {
    getCronogramaCompra,
    getDataUsers,
    getDataAlcadas,
    getDataFerias,
    getDataTolerancias
  }

  useEffect(() => {
    getFilters({
      companies: true,
      centers: true,
      distributionCenters: true,
      centersConfig: true,
      users: true,
      profiles: true
    })
  }, [getFilters])

  // Empresa padrão: a primeira do perfil
  useEffect(() => {
    if (!companieId && authCompanies?.length >= 1) {
      handleCompanieId({ value: authCompanies[0] })
    }
  }, [companieId, authCompanies, handleCompanieId])

  // Uma única busca por aba ativa (na troca de aba ou de empresa).
  // Alçadas/Férias/Compradores/Cronograma usam cache por empresa no provider.
  useEffect(() => {
    if (!companieId) return
    const f = fetchers.current
    switch (tabIndex) {
      case 0: // Cronograma
        f.getCronogramaCompra?.(companieId)
        break
      case 1: // Compradores
        f.getDataUsers?.(companieId)
        break
      case 2: // Alçadas
        f.getDataAlcadas?.(companieId)
        break
      case 3: // Férias
        f.getDataFerias?.(companieId)
        break
      case 4: // Tolerância
        f.getDataTolerancias?.(companieId)
        break
      case 5: // Escopo
        // dados carregados via prop empresaId no EscopoConfigPurchase
        break
    }
  }, [companieId, tabIndex])

  return (
    <Layout title="Config Compras">
      <Grid w="50vw" bg="white" h="40vh" templateColumns="95vw">
        <Box>
          <Tabs
            variant="soft-rounded"
            colorScheme="green"
            index={tabIndex}
            onChange={setTabIndex}
            // Monta só a aba aberta (cada aba faz as próprias buscas/filtros)
            isLazy
          >
            <TabList>
              <Tab>Cronograma</Tab>
              <Tab>Compradores</Tab>
              <Tab>Alçadas</Tab>
              <Tab>Férias</Tab>
              <Tab>Tolerância</Tab>
              <Tab>Escopo</Tab>
              <Spacer />

              <Box w={300} pt={4} pr={4}>
                <Filter
                  label=""
                  options={companies}
                  isMulti={false}
                  value={(() => {
                    // Tratativa para inconsistência entre companieId e companies
                    if (!companieId) return []

                    const foundCompany = companies.find(
                      company => company.value === companieId
                    )

                    // Se encontrou a empresa na lista, retorna
                    if (foundCompany) {
                      return [foundCompany]
                    }

                    // Se não encontrou mas tem companieId, cria um placeholder
                    if (companieId && companies.length === 0) {
                      return [
                        {
                          value: companieId,
                          label: `${companieId}` // Placeholder até carregar
                        }
                      ]
                    }

                    return []
                  })()}
                  onChange={(values: any) => {
                    if (!values?.value || values.value === companieId) return
                    // Trocar de empresa descarta alterações não salvas do calendário
                    if (
                      confirmDiscardCronograma &&
                      !confirmDiscardCronograma()
                    ) {
                      return
                    }
                    // A busca da aba ativa é feita pelo efeito acima
                    handleCompanieId(values)
                  }}
                  isLoading={loading || !companies.length}
                />
              </Box>
            </TabList>
            <TabPanels>
              <TabPanel>
                <CronogramaCompraCalendar />
              </TabPanel>

              <TabPanel>
                <PurchaseCronUserConfig />
              </TabPanel>
              <TabPanel>
                <PurchaseCronAlcadaConfig />
              </TabPanel>
              <TabPanel>
                <PurchaseCronFeriasConfig />
              </TabPanel>
              <TabPanel>
                <PurchaseCronToleranciaConfig />
              </TabPanel>
              <TabPanel>
                <EscopoConfigPurchase empresaId={companieId || undefined} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Grid>
    </Layout>
  )
}
export default PurchaseConfig
